module.exports = __webpack_public_path__ + "static/media/2030105000.acf218fe.jpg";